import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

/**
 * @deprecated Use `useWorkflowTemplate` instead.
 */
export function useWorkflowTemplateWithCardDefinition(id?: string | null): {
  workflowTemplate?: API.WorkflowTemplateWithCardDefinitionFragment;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    API.GetWorkflowTemplateWithCardDefinitionQuery,
    API.GetWorkflowTemplateWithCardDefinitionQueryVariables
  >(Queries.workflow.getWorkflowTemplateWithCardDefinition, {
    variables: { id: id ?? '' },
    skip: isNil(id),
  });
  const workflowTemplate = data?.getWorkflowTemplate ?? undefined;
  return { workflowTemplate, loading, error };
}
